/** @module Camunda/PriorityIconOnTaskRenderer */
define([
	"dojo/_base/declare",
	"csi/task/PriorityIconRenderer",
	"csi/task/util",
], function(declare, PriorityIconRenderer, TaskUtil) {

	return declare(PriorityIconRenderer, {
		/**
		 * @override
		 * Return the priority of the task
		 */
		getPriorityId: function(ctx) {
			return ctx.getNode().Priority;
		},

		/**
		 * @override
		 * Render nothing if task is complete
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			return TaskUtil.isTaskActive(ctx.getNode()) ? this.inherited(arguments) : false;
		}
	});
});